module.exports = __webpack_public_path__ + "1b8e08039fb3b2bea48fcf07da439893.jpg";